"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockSuccessRequest = exports.mockFailRequest = exports.mockError = exports.mockData = void 0;
// framework
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
// mocks
class MockError {
    constructor() {
        this.message = 'MOCK_ERROR';
    }
}
exports.mockData = { name: 'user', age: 23 };
exports.mockError = new MockError();
const mockFailRequest = async () => Promise.resolve(web_ui_framework_1.ErrorResult.create(exports.mockError));
exports.mockFailRequest = mockFailRequest;
const mockSuccessRequest = async () => Promise.resolve(web_ui_framework_1.SuccessResult.create(exports.mockData));
exports.mockSuccessRequest = mockSuccessRequest;
//# sourceMappingURL=mocks.js.map